import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  getspecificSingleProductbyname,
  getspecificSingleProductbyProductCode,
} from "../../../actions/singleProductAction";
import { getspecificproductvariation } from "../../../actions/variableProductAction";
import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Select,
  Divider,
  AutoComplete,
  Form,
} from "antd";
const { Option } = Select;

const product_code = ({
  getspecificSingleProductbyname,
  getspecificproductvariation,
  setvariations,
  products,
  loading,
}) => {
  useEffect(() => {}, [products]);
  // const onKeyUp = (event) => {
  //   if (event.keyCode == 13) {
  //     getspecificSingleProductbyProductCode(event.target.value).then(
  //       (product) => {
  //         console.log(product);
  //         if (product.count > 0) {
  //           // getspecificproductvariation(product.results[0].id).then((vari) => {
  //           //   // console.log(vari);
  //           //   setvariations(vari);
  //           // });
  //           // setproducts(product.results);
  //         } else {
  //           alert("No product found with this code");
  //         }
  //       }
  //     );
  //   }
  // };
  if (loading) return "Loading...";
  else
    return (
      <>
        <h3>Product Name</h3>
        <Select
          style={{ width: "100%" }}
          placeholder="Products"
          onChange={(value) => {
            setvariations(products.find((o) => o.id === value).variations);
            // qty.current = variations.find((o) => o.id === value).quantity;
          }}
        >
          {products.map((product) => {
            return <Option value={product.id}>{product.title}</Option>;
          })}
        </Select>
      </>
    );
};

export default connect(null, {
  getspecificSingleProductbyname,
  getspecificproductvariation,
  getspecificSingleProductbyProductCode,
})(product_code);
